/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_SMILE_ICON': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g transform="translate(1 1)" _fill="none" fill-rule="evenodd"><circle pid="0" _stroke="currentColor" cx="9" cy="9" r="9"/><circle pid="1" _fill="currentColor" cx="6" cy="7" r="1"/><circle pid="2" _fill="currentColor" cx="12" cy="7" r="1"/><path pid="3" d="M5 11c.667 1.333 2 2 4 2s3.333-.667 4-2" _stroke="currentColor"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_SMILE_ICON.js